<comp-dialog>
  <ng-container comp-dialog-header-title>{{
    'model.finding.status.confirmDialog.changeState.headline'
      | translate
        : {
            newState: ('model.finding.status.' + newStatus() | translate),
          }
  }}</ng-container>

  <ng-container comp-dialog-content>
    <p>
      {{
        'model.finding.status.confirmDialog.changeState.message'
          | translate
            : {
                oldState: ('model.finding.status.' + previousStatus() | translate),
                newState: ('model.finding.status.' + newStatus() | translate),
              }
      }}
    </p>
    <form id="finding-state-justification-form" [formGroup]="form()" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" [floatLabel]="'always'" class="outlined-form-element">
        <mat-label>{{
          'model.finding.status.confirmDialog.changeState.justification' | translate
        }}</mat-label>
        <textarea
          compAutofocus
          [formControlName]="justificationFormControlName"
          matInput
          required
          class="outlined-form-element textarea large"
        ></textarea>
        @if (form().get(justificationFormControlName)?.hasError('required')) {
          <mat-error>{{ 'general.validation.required' | translate }}</mat-error>
        }
        @if (form().get(justificationFormControlName)?.hasError('maxlength')) {
          <mat-error
            >{{
              'general.validation.maxlength'
                | translate
                  : {
                      length: form().get(justificationFormControlName)?.getError('maxlength')
                        ?.requiredLength,
                    }
            }}
          </mat-error>
        }
      </mat-form-field>
    </form>
  </ng-container>
  <ng-container comp-dialog-footer>
    <comp-card-buttons>
      <ng-container ngProjectAs="[right]">
        <button comp-button="secondary" type="button" (click)="onCancel()">
          {{ 'general.cancel' | translate }}
        </button>
        <button
          comp-button
          action="save"
          type="submit"
          form="finding-state-justification-form"
          [disabled]="form().get('justification')?.invalid"
        >
          {{ 'general.save' | translate }}
        </button>
      </ng-container>
    </comp-card-buttons>
  </ng-container>
</comp-dialog>
